import React, { Fragment, useCallback, useEffect, useState } from "react";
import { TextTitle } from "../../../components/atoms/text/titles";
import { AddressType } from "./types";
import { AddressView } from "../address";
import { CustomButton } from "../../../components/atoms/buttons";
import { useParams } from "react-router-dom";
import { PostToBackoffice } from "../../../utils/commands";
import { useSelector } from "react-redux";
import { RootState } from "../../../state/configureStore";
import { FetchFromBackoffice } from "../../../utils/request";
import { Alert, Box, IconButton, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { padding } from "../../../theme";
import { DateTime } from "luxon";

type RequestState = {
  invoiceId: string;
  result: boolean;
  executePostResult: boolean;
  year: string;
  month: string;
  createdAt: string;
};

export const InvoiceHeader = ({
  nodeName,
  invoiceNumber,
  address,
  billingPeriod,
  year,
  month,
}: {
  invoiceNumber?: string;
  nodeName?: string;
  address?: AddressType;
  billingPeriod: string | undefined;
  year: number;
  month: number;
}) => {
  const { customerId } = useParams();
  const user = useSelector((state: RootState) => state.authenticated_user);

  const [requestState, setrequestState] = useState<RequestState | undefined>(undefined);
  const [isDelivered, setIsDelivered] = useState<boolean>(false);
  const [isExecuted, setIsExecuted] = useState<boolean>(false);

  let title = nodeName && `Invoice for ${nodeName}`;
  if (invoiceNumber) title += ` (${invoiceNumber})`;

  useEffect(() => {
    const getInvoiceStatus = async () => {
      try {
        const result: RequestState = await FetchFromBackoffice(
          `customers/${customerId}/invoice/requst/status/${year}/month/${month}`,
        );
        if (result) {
          setrequestState(result);
          setIsDelivered(result.executePostResult);
          setIsExecuted(result.result);
        } else {
          setrequestState(undefined);
        }
      } catch (error) {
        console.error("Fetch error", error);
      }
    };

    getInvoiceStatus();
  }, [customerId, year, month]);

  const sendInvoice = useCallback(async () => {
    const result = await PostToBackoffice("cmd/invoice/request", {
      month: month,
      year: year,
      nodeId: customerId,
      requestedBy: user?.name,
    });
    
    console.log("TurboLog ~ InvoiceHeader ~ result:", result)
   if (result.data !== undefined) {
        setrequestState({
          invoiceId: result?.data?.invoiceId,
          result: true,
          executePostResult: false,
          year: year.toString(),
          month: month.toString(),
          createdAt: DateTime.now().toString(),
        });
        setIsExecuted(true);
        setIsDelivered(false);
    }
  }, [year, month, customerId, user?.name]);

  return (
    <>
      <div className="right">{billingPeriod}</div>
      {title && <TextTitle title={title} />}

      {address && (
        <AddressView
          address={{
            ...address,
            streetAddress: address.addressLine1,
            extraAddress: address.addressLine2,
          }}
        />
      )}
      <Box
        className="right"
        sx={{
          flexDirection: "row",
          display: "flex",
          gap: padding,
          justifyContent: "flex-end",
          alignItems: "center"
        }}
      >
        {requestState?.result ? (
        <Box sx={{display: "flex", flexDirection: "column" , gap: padding/4}}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, justifyContent: "flex-end" }}>
            <Alert
              severity={isExecuted && isDelivered ? "success" : "warning"}>
                       {isExecuted && isDelivered ? "Uploaded" : "Pending..."}
            </Alert>

          </Box>
                    
            {requestState.createdAt && (
              <Typography variant="body2">
                Requested at{" "}
                {DateTime.fromISO(requestState.createdAt).toFormat("yyyy-MM-dd HH:mm")}
              </Typography>
            )}
          </Box>
        ) : (
          <Box
            sx={{
              flexDirection: "row",
              display: "flex",
              alignItems: "center",
              gap: padding,
            }}
          >
            <CustomButton onClick={sendInvoice}>
              Send Invoice
            </CustomButton>
          </Box>
        )}
      </Box>
    </>
  );
};